import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t, i18n } = useTranslation();

  return (
    <footer
      dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
      className='p-4 sm:p-6 xl:p-8 space-y-2'>
      <p className='text-sm text-center text-gray-500 dark:text-gray-400 mb-0'>
        &copy; {new Date().getFullYear()} - Quizly - {t('footer')}
      </p>
      <p
        dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
        className='text-sm text-center text-gray-500 dark:text-gray-400 mb-0'>
        {t('landing-powered-by')}{' '}
        <a
          className='hover:underline'
          href='https://near.org/'
          target='_blank'
          rel='noreferrer'>
          NEAR
        </a>
      </p>
    </footer>
  );
};

export default Footer;
